<template>
    <div id="app" >
        <router-view ref="container" />
    </div>
</template>

<script>
    export default {
        name: "App",
        data: () => ({

        }),
        mounted(){
        },
        created() {
          const oScript = document.createElement('script');
          oScript.type = 'text/javascript';
          oScript.src = 'https://res2.wx.qq.com/open/js/jweixin-1.6.0.js';
          oScript.onload = this.wxmini
          document.body.appendChild(oScript);
          this.initWechatJs()
        },
        methods: {
            initWechatJs(){
                let url = encodeURIComponent(location.href.split('#')[0])
                this.fetchData('/wechat/jssdk',{url:url},(res)=>{
                    if(res.code){
                        wx.config(res.data);
                        wx.ready(()=>{
                            wx.hideMenuItems({
                                menuList: [
                                    "menuItem:share:appMessage",
                                    "menuItem:share:timeline",
                                    "menuItem:share:qq",
                                    "menuItem:share:weiboApp",
                                    "menuItem:share:facebook",
                                    "menuItem:share:QZone",
                                    "menuItem:copyUrl",
                                    "menuItem:originPage",
                                    "menuItem:openWithQQBrowser",
                                    "menuItem:openWithSafari",
                                    "menuItem:readMode"
                                ]
                            });
                        })
                    }
                })
            },
        }
    };

    (function (win, doc) {
        if (!win.addEventListener) return
        let html = document.documentElement
        function setFont() {
            let cliWidth = document.body.clientWidth
            let cliHeight= window.innerHeight
          console.log(cliHeight)
            html.setAttribute('style', 'font-size: ' + 100 * (cliWidth / 750) + 'px;height:'+cliHeight+'px;overflow-y:scroll;');
        }
        win.addEventListener('resize', setFont, false);
        doc.addEventListener('DOMContentLoaded', setFont, false)
    })(window, document)
</script>


<style>
    body, html {
        padding: 0;
        margin: 0;
    }
    html{
      background: -webkit-gradient(linear, left top, right  bottom, from(#FF9090FF), to(#F05864FF));
      background: linear-gradient(135deg, #FF9090FF,#F05864FF);
    }
    body{
      height: inherit;
    }
    #app {
        font-family: "微软雅黑";
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        height: inherit;
        width: 100%;
    }

</style>



// WEBPACK FOOTER //
// src/App.vue